export default "__VITE_ASSET__BFdAIgwu__"